export default __webpack_public_path__ + "static/media/Audio.7067ef34.svg";